import { render } from "./TransformTools.vue?vue&type=template&id=2b794426&scoped=true"
import script from "./TransformTools.vue?vue&type=script&lang=js"
export * from "./TransformTools.vue?vue&type=script&lang=js"

import "./TransformTools.vue?vue&type=style&index=0&id=2b794426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b794426"]])

export default __exports__